.dragger-resizer {
  position: absolute;
  width: 100%;
  height: 100%;
}

.dragger-resizer:not(.dragger-resizer--selected):hover:not(:has(.dragger-resizer:hover)) {
  z-index: 1;
  background-color: var(--blue-200);
}

.dragger-resizer--selected {
  cursor: pointer;
  border: 1px solid var(--blue-600);
}

.anchor {
  position: absolute;
  background-color: var(--blue-600);
  width: 12px;
  height: 12px;
  z-index: 1;
}

.anchor-left {
  .anchor;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
}

.anchor-left:hover {
  cursor: w-resize;
}

.anchor-right {
  .anchor;
  right: -18px;
  top: 50%;
  transform: translateY(-50%);
}

.anchor-right:hover {
  cursor: w-resize;
}

.anchor-bottom {
  .anchor;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
}

.anchor-bottom:hover {
  cursor: s-resize;
}

.anchor-top {
  .anchor;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
}

.anchor-top:hover {
  cursor: s-resize;
}
